export enum TRIAL_SHOW_CASE_STEPS {
  FIRST_CLASSROOM = 'firstClassroom',
  MICROCERTIFICATE = 'microcertificate',
  LIVE_CLASSROOM = 'liveClassroom',
  SELECTIVE_PROCESS = 'selectiveProcess',
  DISCOUNT = 'discount',
}
